module.exports = __webpack_public_path__ + "img/SUDISA.ea613918.png";